export const translations = {
  en: {
    hero: {
      headline: "The Only Bars Worth Your Time In Barberà.",
      subhead: "We tested them all. We only list the number one spot in each category. No tourist traps. No bad drinks.",
      optIn: "Want a free drink tonight? Enter your details.",
      emailPlaceholder: "your@email.com",
      firstNamePlaceholder: "First Name",
      lastNamePlaceholder: "Last Name",
      gdprLabel: "I agree to receive email updates and promotions.",
      submitBtn: "Get Free Drink",
      successTitle: "Success!",
      successMessage: "Check your inbox for your free drink voucher.",
      getAccess: "Get Access"
    },
    journal: {
      title: "The Selection Process",
      subtitle: "Inside Barberà's Elite Directory",
      intro: "Our journey through Barberà del Vallès isn't just about finding a place to sit. It's an obsession with the culinary soul of the Vallès Occidental. We've spent months navigating the streets near Barcelona to curate a list that accepts nothing but perfection.",
      foodTitle: "The Golden Tapas Standard",
      foodContent: "To us, 'Las Mejores Tapas' isn't a marketing slogan; it's a structural requirement. We look for the translucency of hand-carved Ibérico ham, the precise crunch-to-fluff ratio of a patatas brava, and the soul of a kitchen that understands the heritage of Spanish regional ingredients.",
      drinkTitle: "Craft Beer Excellence",
      drinkContent: "The rise of 'Cerveza Artesana' in the region has been meteoric. We only partner with establishments that respect the cold chain, maintain their lines with surgical precision, and prioritize local micro-breweries that define the unique taste of our valley.",
      vibeTitle: "The Art of the Pour",
      vibeContent: "Atmosphere is the silent ingredient. Whether it's the specific density of ice in a cocktail or the two-part settle of a perfect pint, we evaluate the rhythm of the bar. If it doesn't feel like an escape from the ordinary, it simply doesn't make the list.",
      backBtn: "Back to Directory"
    },
    categories: {
      tapas: "The Best Tapas",
      cocktails: "The Best Cocktails",
      pint: "The Best Pint",
      ipa: "The Best IPA Beers",
      craftbeer: "The Best Craft Beer",
      noodles: "The Best Noodles",
      breakfast: "The Best Breakfast"
    },
    ui: {
      selection: "The Selection",
      viewMenu: "View The Menu",
      footer: "Curated for Barberà del Vallès",
      directory: "Directory",
      back: "Back",
      imprint: "Imprint",
      privacy: "Privacy Policy",
      journal: "Journal"
    },
    legal: {
      imprintTitle: "Legal Notice",
      privacyTitle: "Privacy Policy",
      responsible: "Responsible for content",
      address: "Address",
      contact: "Contact",
      sections: {
        s1_title: "1. Responsible for Data Processing",
        s1_content: "The responsible party for data processing on this website is:",
        s2_title: "2. Data Collection and Processing",
        s2_content: "We collect and process personal data only when it is necessary to provide a functional website, content, and our services. If you contact us by email, the data you provide (e.g., your email address, name, and the content of your message) will be stored by us in order to process your request and respond to your inquiry.This website does not use any cookies or similar tracking technologies.",
        s3_title: "3. Newsletter and SendFox",
        s3_content1: "If you would like to receive the newsletter offered on the website, we require an email address from you. We use SendFox, a service provided by Sumo Group Inc., 1305 E 6th St #3, Austin, TX 78702, USA, to send our newsletters.",
        s3_content2: "When you register for our newsletter, the data you provide (such as your email address) is transferred to SendFox and stored on their servers in the USA. The legal basis for processing your data for the newsletter is your explicit consent (Art. 6 (1) lit. a GDPR). You can revoke your consent to the storage of the data, the email address, and their use for sending the newsletter at any time, for example, via the \"unsubscribe\" link in the newsletter.",
        s4_title: "4. Legal Basis for Processing",
        s4_content: "The processing of data entered when contacting us is based on your consent (Art. 6 (1) lit. a GDPR) or for the performance of a contract or pre-contractual measures (Art. 6 (1) lit. b GDPR).",
        s5_title: "5. Data Retention",
        s5_content: "We retain your personal data only for as long as is necessary for the respective purpose or as required by legal retention periods. After that, the corresponding data is routinely deleted.",
        s6_title: "6. Your Rights",
        s6_content1: "Under the GDPR, you have the right to request information about your stored personal data at any time. Furthermore, you have the right to request the correction, restriction of processing, or deletion of this data.",
        s6_content2: "You also have the right to data portability and the right to lodge a complaint with the competent supervisory authority (in Spain: Agencia Española de Protección de Datos - AEPD).",
        footer: "To exercise your rights, simply send an email to:"
      }
    }
  },
  es: {
    hero: {
      headline: "Los Únicos Bares Que Valen La Pena En Barberà.",
      subhead: "Los probamos todos. Solo listamos el número uno de cada categoría. Cero trampas para turistas. Cero tragos malos.",
      optIn: "¿Quieres una bebida gratis esta noche? Déjanos tus datos.",
      emailPlaceholder: "tu@email.com",
      firstNamePlaceholder: "Nombre",
      lastNamePlaceholder: "Apellido",
      gdprLabel: "Acepto recibir actualizaciones y promociones por correo electrónico.",
      submitBtn: "Obtener Bebida",
      successTitle: "¡Éxito!",
      successMessage: "Revisa tu correo para tu bebida gratis.",
      getAccess: "Obtener Acceso"
    },
    journal: {
      title: "El Proceso de Selección",
      subtitle: "Dentro del Directorio de Élite de Barberà",
      intro: "Nuestro viaje por Barberà del Vallès no se trata solo de encontrar un lugar donde sentarse. Es una obsesión con el alma culinaria del Vallès Occidental. Hemos pasado meses recorriendo las calles cerca de Barcelona para curar una lista que no acepta nada menos que la perfección.",
      foodTitle: "El Estándar de Oro de las Tapas",
      foodContent: "Para nosotros, 'Las Mejores Tapas' no es un eslogan publicitario; es un requisito estructural. Buscamos la transparencia del jamón ibérico cortado a mano, la proporción precisa entre crujiente y esponjoso de una patata brava, y el alma de una cocina que entiende la herencia de los ingredientes regionales españoles.",
      drinkTitle: "Excelencia en Cerveza Artesana",
      drinkContent: "El auge de la 'Cerveza Artesana' en la región ha sido meteórico. Solo colaboramos con establecimientos que respetan la cadena de frío, mantienen sus grifos con precisión quirúrgica y priorizan las microcervecerías locales que definen el sabor único de nuestro valle.",
      vibeTitle: "El Arte de la Mezcla",
      vibeContent: "La atmósfera es el ingrediente silencioso. Ya sea la densidad específica del hielo en un cóctel o el reposo en dos tiempos de una pinta perfecta, evaluamos el ritmo del bar. Si no se siente como una escapada de lo ordinario, simplemente no entra en la lista.",
      backBtn: "Volver al Directorio"
    },
    categories: {
      tapas: "Las Mejores Tapas",
      cocktails: "Los Mejores Cócteles",
      pint: "La Mejor Pinta",
      ipa: "Las Mejores Cervezas IPA",
      craftbeer: "La Mejor Cerveza Artesana",
      noodles: "Los Mejores Tallarines",
      breakfast: "El Mejor Desayuno"
    },
    ui: {
      selection: "La Selección",
      viewMenu: "Ver El Menú",
      footer: "Curado para Barberà del Vallès",
      directory: "Directorio",
      back: "Volver",
      imprint: "Aviso Legal",
      privacy: "Privacidad",
      journal: "Diario"
    },
    legal: {
      imprintTitle: "Aviso Legal",
      privacyTitle: "Política de Privacidad",
      responsible: "Responsable del contenido",
      address: "Dirección",
      contact: "Contacto",
      sections: {
        s1_title: "1. Responsable del Tratamiento de Datos",
        s1_content: "El responsable del tratamiento de los datos en este sitio web es:",
        s2_title: "2. Recopilación y Tratamiento de Datos",
        s2_content: "Recopilamos y tratamos datos personales solo cuando es necesario para proporcionar un sitio web funcional, sus contenidos y nuestros servicios. Si se pone en contacto con nosotros por correo electrónico, los datos que proporcione (por ejemplo, su dirección de correo electrónico, nombre y el contenido de su mensaje) serán almacenados por nosotros para poder procesar su solicitud y responder a su consulta.Este sitio web no utiliza cookies ni tecnologías de seguimiento similares.",
        s3_title: "3. Boletín informativo (Newsletter) y SendFox",
        s3_content1: "Si desea recibir el boletín ofrecido en el sitio web, requerimos una dirección de correo electrónico suya. Utilizamos SendFox, un servicio operado por Sumo Group Inc., 1305 E 6th St #3, Austin, TX 78702, EE. UU., para enviar nuestros boletines.",
        s3_content2: "Al registrarse para recibir nuestro boletín, los datos que proporcione (como su dirección de correo electrónico) se transmiten a SendFox y se almacenan en sus servidores en los Estados Unidos. La base legal para el tratamiento de sus datos para el envío del boletín es su consentimiento explícito (Art. 6 apdo. 1 letra a del RGPD). Puede revocar su consentimiento para el almacenamiento de los datos, la dirección de correo electrónico y su uso para el envío del boletín en cualquier momento, por ejemplo, a través del enlace para darse de baja (\"unsubscribe\") que aparece en cada boletín.",
        s4_title: "4. Base Legal para el Tratamiento",
        s4_content: "El tratamiento de los datos facilitados al contactarnos se basa en su consentimiento (Art. 6 apdo. 1 letra a del RGPD) o para la ejecución de un contrato o medidas precontractuales (Art. 6 apdo. 1 letra b del RGPD).",
        s5_title: "5. Conservación de los Datos",
        s5_content: "Conservamos sus datos personales solo durante el tiempo necesario para el propósito respectivo o según lo exijan los plazos de conservación legales. Después de este período, los datos correspondientes se eliminan de forma rutinaria.",
        s6_title: "6. Sus Derechos",
        s6_content1: "En virtud del RGPD, tiene derecho a solicitar en cualquier momento información sobre sus datos personales almacenados. Además, tiene derecho a solicitar la rectificación, limitación del tratamiento o supresión de estos datos.",
        s6_content2: "También tiene derecho a la portabilidad de los datos y el derecho a presentar una reclamación ante la autoridad de control competente (Agencia Española de Protección de Datos - AEPD).",
        footer: "Para ejercer sus derechos, simplemente envíe un correo electrónico a:"
      }
    }
  }
};